import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import moment from "moment";

import { firebaseConfig } from "./config";
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export const db = firebase.firestore();
db.enablePersistence();

let urlParams = new URLSearchParams(window.location.search);
Vue.prototype.$id = urlParams.get("id");

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.filter("readableDateTime", (value) => {
	return moment(value).format("MMMM DD, YYYY hh:mm A");
});

Vue.filter("timeAgo", (value) => {
	return moment(value).fromNow();
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
